import { Injectable } from '@angular/core';
import { ICacheChanges } from '../models/cacheChanges/cacheChanges.interface';
import { SportsService } from './sports.service';
import { EventVM } from '../models/event/event';
import { UtilityService } from './util/utility.service';
import { IBetTypeSelection } from '../models/betType/betTypeSelection.interface';
import { BetTypeSelectionSBVSelectionType, SBVSelectionType, BetOutcomeOddDifference, TreeLevel, EventMappingType, EventType, SpecialOfferType, EventStatus } from '../models/enums';
import { IBet } from '../models/bet/bet';
import { IBetOutcome } from '../models/bet/betOutcome.interface';
import { IBetGroupWithBetToShowId } from '../models/bet/betGroupWithBetToShow.interface';
import { EventsService } from './events.service';
import { ITicketItemGroup } from '../models/ticket/ticketItemGroup.interface';
import { IBetTypeShowTypeWithBets } from '../models/bet/betsAndBetTypeShowTypeWithOnlineStatus.interface';
import { IBetTypeGroup } from '../models/betType/betTypeGroup.interface';
import { SettingsService } from './settings.service';
import { IBetTypeShowType } from '../models/betType/betTypeShowType.interface';
import { IBetTypeGroupingTemplateItem } from '../models/betType/betTypeGroupingTemplateItem.interface';
import { ISrcSelectionIds } from '../models/util/srcSelectionIds.interface';
import { ViewConfigurations } from '../models/util/viewConfigurations';
import { ConstantValues } from '../models/util/constantValues';

@Injectable()
export class ChangesUpdaterService {
  betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType };

  constructor(
    private sportsService: SportsService,
    private utilityService: UtilityService,
    private eventsService: EventsService,
    private settingsService: SettingsService) {
    this.settingsService.getBetTypeShowTypes().subscribe((btst) => {
      // console.log('CHANGES UPDATER GetBettypeshowtypes');
      this.betTypeShowTypes = btst;
    });
  }
  // napravi slicnu f-ju za live moze i ova samo ako je live sport trazi iz tree koje je na servisu ili u komponenti napravi mini tree-dictionary sa osnovnim podacima(vidi mozda i mozdes iz podataka na eventu da pravis sta ti treba)
  // moze i ovo sa sport region competition izbaciti kao i ovaj prvi if za proveru, onda izmeni ovo okoo vog gde je is live -- mozda u ovaj prvi if samo dodati ako su sva 3 null da moze da radi(nista nije selektovano, znaci sve se prikazuje)
  // ovde bi usustini moglo i biti onaj kompleksiniji selections jer ce i na desktopu trebati da se prikazuje sve (samo se posle prosledi samo za taj sport selections ili za competition- u zavisnosti od orderinga)
  updateEventsChanges(events: { [id: number]: EventVM }, cacheChanges: ICacheChanges, selections: { [hierarchyId: number]: { [betTypeId: number]: IBetTypeSelection } }, isPrematch: boolean, areMostPopularOrSoonEvents: boolean = false, specialOfferType?: SpecialOfferType): { eventAddedRemoved: boolean; srcToDecrement: ISrcSelectionIds[] } {
    // events with updated datetime
    const srcsToChangeCount: ISrcSelectionIds[] = [];
    let eventAddedRemoved = false;
    const dateNow = new Date();

    const sportId = this.sportsService.sportRegionCompetitionSelection.sport && !this.sportsService.sportRegionCompetitionSelection.sport.specialOfferType ? this.sportsService.sportRegionCompetitionSelection.sport.id : null;
    const regionId = this.sportsService.sportRegionCompetitionSelection.region ? this.sportsService.sportRegionCompetitionSelection.region.id : null;
    const competitionId = this.sportsService.sportRegionCompetitionSelection.competition ? this.sportsService.sportRegionCompetitionSelection.competition.id : null;
    const expandedEvent = this.eventsService.expandedEventGet();
    const dates = this.utilityService.getDateFromTo(false, this.sportsService.timeFilterValueGet);
    for (const event of cacheChanges.changedEvents) {
      if (this.sportsService.sportRegionCompetitionSelection.sport && this.sportsService.sportRegionCompetitionSelection.sport.specialOfferType && this.sportsService.sportRegionCompetitionSelection.sport.specialOfferType !== event.specialOfferType) {
        continue;
      }
      if (competitionId === event.competitionId || (!competitionId && regionId === event.regionId) || (!regionId && sportId === event.sportId) || (!sportId)) {
        if (events[event.id]) {
          if (!event.isInOffer || (!event.isLive && event.dateTime <= dateNow)) {
            // event removed
            if (expandedEvent && expandedEvent.id === event.id) {
              if (ViewConfigurations.delayRemovingFinishedLiveEvent && event.isLive && event.status === EventStatus.Finished) {
                event.isPlayable = false;
                events[event.id].updateEventDetails(event);
                setTimeout(() => {
                  this.eventsService.removeExpandedEventFromOffer();
                  delete events[event.id];
                  eventAddedRemoved = true;
                }, ViewConfigurations.timeToDelayRemovingFinishedLiveEvent);
                continue;
              } else {
                this.eventsService.removeExpandedEventFromOffer();
              }
            }
            delete events[event.id];
            eventAddedRemoved = true;
            continue;
          }

          if (!event.isLive && (event.dateTime < dates.dateFrom || event.dateTime > dates.dateTo)) {
            delete events[event.id];
            eventAddedRemoved = true;
            srcsToChangeCount.push({
              sId: event.sportId,
              rId: event.regionId,
              cId: event.competitionId,
              sOT: event.specialOfferType
            } as ISrcSelectionIds);
            continue;
          }

          events[event.id].updateEventDetails(event);
        } else {
          if (areMostPopularOrSoonEvents) {
            continue;
          }
          if (event.isInOffer && (event.isLive || (!event.isLive && event.dateTime > dateNow))) {
            if (isPrematch) {
              if (event.dateTime < dates.dateFrom || event.dateTime > dates.dateTo) {
                if (events[event.id]) {
                  delete events[event.id];
                  eventAddedRemoved = true;
                }
                continue;
              }
            }

            if ((!specialOfferType && event.mappingType === EventMappingType.SuperBetEvent && !ViewConfigurations.showSpecialEventsInStandardOffer)
              ||
              (specialOfferType && specialOfferType !== event.specialOfferType)) {
              continue;
            }
            events[event.id] = event;
            // go for other details for event for later
            // this.createBetGroupsForEvent(event, Object.entries(selections).map(([k, v]) => v));
            this.eventsService.getBetsAndGroups(event).subscribe((betsAndGroups) => this.fillEventWithInitialBets(event, betsAndGroups.bets, selections, competitionId ? event.competitionId : regionId ? event.regionId : event.sportId));
            eventAddedRemoved = true;
          }
        }
      }
    }

    // later ask for length if null de select and select next first hierarchy if not null do this(notify service to send length to tree)
    return { eventAddedRemoved, srcToDecrement: srcsToChangeCount };
  }

  private createBetGroupsForEvent(event: EventVM, selections: IBetTypeSelection[]) {
    for (const selection of selections) {
      if (!event.betGroups[selection.betTypeId]) {

        event.betGroups[selection.betTypeId] = this.utilityService.createBetsGroup();
      }
    }
  }

  private fillEventWithInitialBets(event: EventVM, bets: IBet[], selections: { [hierarchyId: number]: { [betTypeId: number]: IBetTypeSelection } }, hierarchyId: number) {
    event.betsCount = bets.length;
    event.playableBetsCount = 0;
    for (const bet of bets) {
      if (!bet.isInOffer) {
        continue;
      }

      if (!selections[hierarchyId]) {
        continue;
      }

      if (!selections[hierarchyId][bet.betTypeId]) {
        continue;
      }

      if (!event.betGroups[bet.betTypeId]) {
        event.betGroups[bet.betTypeId] = this.utilityService.createBetsGroup();
      }

      let addBet = false;
      if (event.isLive) {
        addBet = true;
      }

      if (bet.isPlayable) {
        event.playableBetsCount++;
        // getting single playable bet and it is not most balanced later chack if most balanced calculation is good
        if ((selections[hierarchyId][bet.betTypeId].sbvSelectionType === BetTypeSelectionSBVSelectionType.Exact && bet.sbv === selections[hierarchyId][bet.betTypeId].sbvExactValue)
          // || (selections[hierarchyId][bet.betTypeId].sbvSelectionType === BetTypeSelectionSBVSelectionType.MostBalanced && bet.isMostBalanced)
          || (selections[hierarchyId][bet.betTypeId].sbvSelectionType === BetTypeSelectionSBVSelectionType.None)) {
          addBet = true;
          event.betGroups[bet.betTypeId].betToShow = bet;
        }

        if (selections[hierarchyId][bet.betTypeId].sbvSelectionType === BetTypeSelectionSBVSelectionType.MostBalanced) {
          if (!event.betGroups[bet.betTypeId].betToShow) {
            event.betGroups[bet.betTypeId].betToShow = bet;
          } else if (bet.betOutcomes.length === 2 && Math.abs(bet.betOutcomes[0].odd - bet.betOutcomes[1].odd) < Math.abs(event.betGroups[bet.betTypeId].betToShow.betOutcomes[0].odd - event.betGroups[bet.betTypeId].betToShow.betOutcomes[1].odd)) {
            event.betGroups[bet.betTypeId].betToShow = bet;
          }
        }
      }

      if (addBet) {
        event.betGroups[bet.betTypeId].bets[bet.id] = bet;
      }
    }
  }

  updateBetChangesNonExpandedEvents(events: { [id: number]: EventVM }, cacheChanges: ICacheChanges, selections: { [hierarchyId: number]: { [betTypeId: number]: IBetTypeSelection } }, isLive: boolean, hierarchyLevel: TreeLevel) {
    for (const bet of cacheChanges.changedBets) {
      const event = events[bet.eventId];
      if (!event) {
        continue;
      }
      const hierarchyId = hierarchyLevel === TreeLevel.Competitions ? event.competitionId : hierarchyLevel === TreeLevel.Regions ? event.regionId : event.sportId;
      if (!event) {
        continue;
      }

      if (!selections[hierarchyId]) {
        continue;
      }

      const selection: IBetTypeSelection = selections[hierarchyId][bet.betTypeId];
      if (!selection) {
        continue;
      }

      const betsGroup = event.betGroups[bet.betTypeId];

      if (bet.isInOffer) { // add or update
        if (!betsGroup) {
          event.betGroups[bet.betTypeId] = this.utilityService.createBetsGroup();
        }

        if (event.betGroups[bet.betTypeId].bets[bet.id]) {
          // update
          this.updateSingleBet(bet, event.betGroups[bet.betTypeId].bets[bet.id]);
          if (selection.sbvSelectionType === BetTypeSelectionSBVSelectionType.MostBalanced) {
            // most balanced prop in not sent as changed - CHECK THIS WITH back end devs
            if (bet.isMostBalanced) {
              event.betGroups[bet.betTypeId].betToShow = event.betGroups[bet.betTypeId].bets[bet.id];
            }
            // use this if isMostBalanced Prop does not work
            // this.setMostBalancedBetAsBetToShowForBetsGroup(event.betGroups[bet.betTypeId]);
          }
        } else {
          // add
          if (selection.sbvSelectionType === BetTypeSelectionSBVSelectionType.Exact && bet.sbv !== selection.sbvExactValue) {
            continue;
          }
          event.betGroups[bet.betTypeId].bets[bet.id] = bet;

          // remove this if  if isMostBalanced Prop does not work// dont add new work flow because outcome added will caculate mosts balanced
          if (selection.sbvSelectionType === BetTypeSelectionSBVSelectionType.MostBalanced && bet.isMostBalanced) {
            event.betGroups[bet.betTypeId].betToShow = bet;
          }

          if (!event.betGroups[bet.betTypeId].betToShow) {
            event.betGroups[bet.betTypeId].betToShow = bet;
          }
        }
      } else {
        // delete

        if (!betsGroup) {
          continue;
        }
        if (betsGroup.bets[bet.id]) {
          delete betsGroup.bets[bet.id];
        }

        if (betsGroup.betToShow && betsGroup.betToShow.id === bet.id) {
          betsGroup.betToShow = null;
        }

        if (selection.sbvSelectionType === BetTypeSelectionSBVSelectionType.MostBalanced) {
          // use this if isMostBalanced Prop does not work!!!!!!
          // this.setMostBalancedBetAsBetToShowForBetsGroup(event.betGroups[bet.betTypeId]);
        }
      }
    }
  }

  updateOutcomeChangesNonExpandedEvents(events: { [id: number]: EventVM }, cacheChanges: ICacheChanges, selections: { [hierarchyId: number]: { [betTypeId: number]: IBetTypeSelection } }, isLive: boolean, hierarchyLevel: TreeLevel) {
    for (const outcome of cacheChanges.changedBetOutcomes) {
      const event = events[outcome.eventId];
      if (!event) {
        continue;
      }
      const hierarchyId = hierarchyLevel === TreeLevel.Competitions ? event.competitionId : hierarchyLevel === TreeLevel.Regions ? event.regionId : event.sportId;
      if (!event) {
        continue;
      }

      if (!selections[hierarchyId]) {
        continue;
      }

      const selection: IBetTypeSelection = selections[hierarchyId][outcome.betTypeId];
      if (!selection) {
        continue;
      }

      let bet: IBet = null;
      if (event.betGroups[outcome.betTypeId]) {
        bet = event.betGroups[outcome.betTypeId].bets[outcome.betId];
      }

      if (!bet) {
        continue;
      }

      if (outcome.isInOffer) {
        const outcomeToUpdate: IBetOutcome = bet.betOutcomesDic[outcome.betTypeOutcomeId] ? bet.betOutcomesDic[outcome.betTypeOutcomeId].find(bo => bo.id === outcome.id) : null;
        // add or update
        if (outcomeToUpdate) {
          // update
          this.updateSingleBetOutcome(outcome, outcomeToUpdate);
          // use this if isMostBalanced Prop does not work!!!!!!
          // if (selection.sbvSelectionType === BetTypeSelectionSBVSelectionType.MostBalanced) {
          // this.setMostBalancedBetAsBetToShowForBetsGroup(event.betGroups[bet.betTypeId]);
          // }
        } else {
          if (!bet.betOutcomesDic[outcome.betTypeOutcomeId]) {
            bet.betOutcomesDic[outcome.betTypeOutcomeId] = [];
          }
          // add
          bet.betOutcomesDic[outcome.betTypeOutcomeId].push(outcome);
          // use this if isMostBalanced Prop does not work!!!!!!!
          // if (selection.sbvSelectionType === BetTypeSelectionSBVSelectionType.MostBalanced) {
          // this.setMostBalancedBetAsBetToShowForBetsGroup(event.betGroups[bet.betTypeId]);
          // }

          // REMOVE LATER, ALSO REMOVE PROPERTY betOutcomes AND find most balanced index EDIT FUNCTION
          bet.betOutcomes.push(outcome);
        }
      } else {
        // delete
        if (!bet.betOutcomesDic[outcome.betTypeOutcomeId]) {
          continue;
        }

        const ind2 = bet.betOutcomesDic[outcome.betTypeOutcomeId].findIndex(bo => bo.id === outcome.id);
        if (ind2 > -1) {
          bet.betOutcomesDic[outcome.betTypeOutcomeId].splice(ind2, 1);
        }
        if (bet.betOutcomesDic[outcome.betTypeOutcomeId].length === 0) {
          delete bet.betOutcomesDic[outcome.betTypeOutcomeId];
        }
        const ind = bet.betOutcomes.findIndex(bo => bo.id === outcome.id);
        if (ind > -1) {
          bet.betOutcomes.splice(ind, 1);
        }
      }
    }
  }

  public updateTicketItemGroups(cacheChanges: ICacheChanges, ticketItemGroups: { [eventId: number]: ITicketItemGroup }, languageCulture: string): number[] {
    this.updateEventsForTicketItemGroups(cacheChanges, ticketItemGroups, languageCulture);
    this.updateBetsForTicketItemGroups(cacheChanges, ticketItemGroups);
    const eventIdsWithChangedOdds: number[] = this.updateOutcomesForTicketItemGroups(cacheChanges, ticketItemGroups);
    return eventIdsWithChangedOdds;
  }

  private updateEventsForTicketItemGroups(cacheChanges: ICacheChanges, ticketItemGroups: { [eventId: number]: ITicketItemGroup }, languageCulture: string) {
    const dateNow = new Date();

    for (const event of cacheChanges.changedEventsForTicket) {
      if (ticketItemGroups[event.id]) {
        ticketItemGroups[event.id].eventDateTime = event.dateTime;
        ticketItemGroups[event.id].eventDate = event.dateTime.toLocaleDateString(languageCulture, { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' });
        ticketItemGroups[event.id].eventTime = event.dateTime.toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' });
        ticketItemGroups[event.id].eventDayShort = event.dateTime.toLocaleDateString(languageCulture, { weekday: 'short' });
        ticketItemGroups[event.id].isEventPlayable = event.isInOffer && event.isPlayable;
        if (!event.isLive && event.dateTime < dateNow) {
          ticketItemGroups[event.id].isEventPlayable = false;
        }
      }

    }
  }

  private updateBetsForTicketItemGroups(cacheChanges: ICacheChanges, ticketItemGroups: { [eventId: number]: ITicketItemGroup }) {
    for (const bet of cacheChanges.changedBetsForTicket) {
      if (!ticketItemGroups[bet.eventId]) {
        continue;
      }
      const ticketitemsForBet = Object.entries(ticketItemGroups[bet.eventId].ticketItems).map(([betTypeOutcomeId, ticketItem]) => ticketItem).filter((ti) => ti.betId === bet.id);
      if (ticketitemsForBet.length === 0) {
        continue;
      }

      for (const ticketItem of ticketitemsForBet) {
        ticketItem.isBetPlayable = bet.isInOffer && bet.isPlayable;
      }
    }
  }

  private updateOutcomesForTicketItemGroups(cacheChanges: ICacheChanges, ticketItemGroups: { [eventId: number]: ITicketItemGroup }): number[] {
    const eventIdsWithChangedOdds: number[] = [];
    for (const bto of cacheChanges.changedBetOutcomesForTicket) {
      if (!ticketItemGroups[bto.eventId]) {
        continue;
      }

      const ticketItem = ticketItemGroups[bto.eventId].ticketItems[bto.id];
      if (!ticketItem) {
        continue;
      }

      if (ticketItem.odd > bto.odd) {
        // if (ticketItem.higherLowerOdd === BetOutcomeOddDifference.Lower) {
        //   ticketItem.higherLowerOdd = BetOutcomeOddDifference.Lower2;
        // } else {
        //   ticketItem.higherLowerOdd = BetOutcomeOddDifference.Lower;
        // }
        if (!eventIdsWithChangedOdds.includes(bto.eventId)) {
          eventIdsWithChangedOdds.push(bto.eventId);
        }
      }

      if (ticketItem.odd < bto.odd) {
        // if (ticketItem.higherLowerOdd === BetOutcomeOddDifference.Higher) {
        //   ticketItem.higherLowerOdd = BetOutcomeOddDifference.Higher2;
        // } else {
        //   ticketItem.higherLowerOdd = BetOutcomeOddDifference.Higher;
        // }
        if (!eventIdsWithChangedOdds.includes(bto.eventId)) {
          eventIdsWithChangedOdds.push(bto.eventId);
        }
      }

      ticketItem.odd = bto.odd;
      ticketItem.isBetOutcomePlayable = bto.isInOffer && bto.isPlayable;
    }
    return eventIdsWithChangedOdds;
  }

  updateResultChanges(events: { [id: number]: EventVM }, cacheChanges: ICacheChanges) {
    for (const result of cacheChanges.changedResults) {
      if (events[result.eventId]) {
        events[result.eventId].result = result;
      }
    }
  }

  public updateExpandedEvent(cacheChanges: ICacheChanges, betsAndBetTypeShowTypes: { [betTypeId: number]: IBetTypeShowTypeWithBets }, selectedBetTypeGroup: IBetTypeGroup, event: EventVM): boolean {
    // eslint-disable-next-line prefer-const
    const betTypeGroupingTemplateItemsForSelectedGroup: { [betTypeId: number]: IBetTypeGroupingTemplateItem } = {};
    if (selectedBetTypeGroup) {
      for (const bgtgi of selectedBetTypeGroup.betTypeGroupingTemplateItems) {
        betTypeGroupingTemplateItemsForSelectedGroup[bgtgi.betTypeId] = bgtgi;
      }
    }

    const refilterSelectedGroup = this.updateBetChangesForExpandedEvent(cacheChanges, betsAndBetTypeShowTypes, betTypeGroupingTemplateItemsForSelectedGroup);
    this.updateOutcomeChangesExpandedEvent(cacheChanges, betsAndBetTypeShowTypes, event);

    return refilterSelectedGroup;
  }

  private updateBetChangesForExpandedEvent(
    cacheChanges: ICacheChanges,
    betsAndBetTypeShowType: { [betTypeId: number]: IBetTypeShowTypeWithBets },
    betTypeGroupingTemplateItemsForSelectedGroup: { [betTypeId: number]: IBetTypeGroupingTemplateItem }): boolean {
    if (!betsAndBetTypeShowType) {
      return false;
    }
    let refilterSelectedGroup = false;
    for (const bet of cacheChanges.changedBetsForExpandedEvent) {
      if (bet.isInOffer) {
        // addBetsAndBetTypeShowType
        if (!betsAndBetTypeShowType[bet.betTypeId]) {
          if (!refilterSelectedGroup && betTypeGroupingTemplateItemsForSelectedGroup[bet.betTypeId]) {
            refilterSelectedGroup = true;
          }
          betsAndBetTypeShowType[bet.betTypeId] = {
            betTypeShowType: null,
            bets: [],
            betsDictionary: {},
            isAnyBetPlayable: false,
            mostBalancedBetIndex: -1,
            isExpanded: true,
            betTypeOutrightName: bet.outrightName
          };
          if (!this.betTypeShowTypes[bet.betTypeId]) {
            console.log('No betTypeShowType for betTypeId: ' + bet.betTypeId);
            return;
          }
          betsAndBetTypeShowType[bet.betTypeId].betTypeShowType = this.betTypeShowTypes[bet.betTypeId];
        }

        if (betsAndBetTypeShowType[bet.betTypeId].betsDictionary[bet.id]) {
          // update
          this.updateSingleBet(bet, betsAndBetTypeShowType[bet.betTypeId].betsDictionary[bet.id]);
          // if isMostBalanced Prop does not work, calculate most balanced!!!!!!
          if (betTypeGroupingTemplateItemsForSelectedGroup[bet.betTypeId] && betTypeGroupingTemplateItemsForSelectedGroup[bet.betTypeId].sbvSelectionType === SBVSelectionType.MostBalanced) {
            // const ind = this.utilityService.getMostBalancedBetIndexFromBetProperty(betsAndBetTypeShowType[bet.betTypeId].bets);
            // calculate there prop is not set on server
            const ind = this.utilityService.getMostBalancedBetIndex(betsAndBetTypeShowType[bet.betTypeId].bets);
            betsAndBetTypeShowType[bet.betTypeId].mostBalancedBetIndex = ind;
          }
          // if (bet.isPlayable) {
          //   betsAndBetTypeShowType[bet.betTypeId].isAnyBetPlayable = true;
          // } else {
          //   if (betsAndBetTypeShowType[bet.betTypeId].isAnyBetPlayable === false) {
          //     if (betsAndBetTypeShowType[bet.betTypeId].bets.findIndex(b => b.isPlayable) > -1) {
          //       betsAndBetTypeShowType[bet.betTypeId].isAnyBetPlayable = true;
          //     } else {
          //       betsAndBetTypeShowType[bet.betTypeId].isAnyBetPlayable = false;
          //     }
          //   }
          // }
        } else {
          // add
          betsAndBetTypeShowType[bet.betTypeId].betsDictionary[bet.id] = bet;
          betsAndBetTypeShowType[bet.betTypeId].bets.push(bet);
          // if isMostBalanced Prop does not work, than we will calculate most balanced when outcomes are added !!!!!!
          if (betTypeGroupingTemplateItemsForSelectedGroup[bet.betTypeId] && betTypeGroupingTemplateItemsForSelectedGroup[bet.betTypeId].sbvSelectionType === SBVSelectionType.MostBalanced) {
            // const ind = this.utilityService.getMostBalancedBetIndexFromBetProperty(betsAndBetTypeShowType[bet.betTypeId].bets);
            // calculate there prop is not set on server
            const ind = this.utilityService.getMostBalancedBetIndex(betsAndBetTypeShowType[bet.betTypeId].bets);
            betsAndBetTypeShowType[bet.betTypeId].mostBalancedBetIndex = ind;
          }

          // if (bet.isPlayable) {
          //   betsAndBetTypeShowType[bet.betTypeId].isAnyBetPlayable = true;
          // }
        }
      } else {
        // delete
        if (!betsAndBetTypeShowType[bet.betTypeId]) {
          continue;
        }
        delete betsAndBetTypeShowType[bet.betTypeId].betsDictionary[bet.id];
        const ind: number = betsAndBetTypeShowType[bet.betTypeId].bets.findIndex(b => b.id === bet.id);
        if (ind > -1) {
          bet.betOutcomes.splice(ind, 1);
        }
        if (betTypeGroupingTemplateItemsForSelectedGroup[bet.betTypeId] && betTypeGroupingTemplateItemsForSelectedGroup[bet.betTypeId].sbvSelectionType === SBVSelectionType.MostBalanced) {
          // const ind = this.utilityService.getMostBalancedBetIndexFromBetProperty(betsAndBetTypeShowType[bet.betTypeId].bets);
          // calculate there prop is not set on server
          const ind = this.utilityService.getMostBalancedBetIndex(betsAndBetTypeShowType[bet.betTypeId].bets);
          betsAndBetTypeShowType[bet.betTypeId].mostBalancedBetIndex = ind;
        }

        // if (betsAndBetTypeShowType[bet.betTypeId].bets.findIndex(b => b.isPlayable) > -1) {
        //   betsAndBetTypeShowType[bet.betTypeId].isAnyBetPlayable = true;
        // }
      }
    }

    return refilterSelectedGroup;
  }

  private updateOutcomeChangesExpandedEvent(
    cacheChanges: ICacheChanges,
    betsAndBetTypeShowType: { [betTypeId: number]: IBetTypeShowTypeWithBets },
    event: EventVM) {
    if (!betsAndBetTypeShowType) {
      return;
    }
    for (const outcome of cacheChanges.changedBetOutcomes) {
      const betTypeShowTypeWithBets = betsAndBetTypeShowType[outcome.betTypeId];

      if (!betTypeShowTypeWithBets) {
        continue;
      }

      const bet = betTypeShowTypeWithBets.betsDictionary[outcome.betId];
      if (!bet) {
        continue;
      }

      if (outcome.isInOffer) {
        // add or update
        const outcomeToUpdate: IBetOutcome = bet.betOutcomesDic[outcome.betTypeOutcomeId] ? bet.betOutcomesDic[outcome.betTypeOutcomeId].find(bo => bo.id === outcome.id) : null;
        if (outcomeToUpdate) {
          // update
          this.updateSingleBetOutcome(outcome, outcomeToUpdate);
        } else {
          // add
          outcome.name = this.utilityService.getBetOutcomeNameFromBTO(outcome, betsAndBetTypeShowType[bet.betTypeId].betTypeShowType, event.homeTeam, event.awayTeam, event.eventType);
          if (!bet.betOutcomesDic[outcome.betTypeOutcomeId]) {
            bet.betOutcomesDic[outcome.betTypeOutcomeId] = [];
          }
          bet.betOutcomesDic[outcome.betTypeOutcomeId].push(outcome);
          bet.betOutcomes.push(outcome);
        }
      } else {
        // delete
        if (!bet.betOutcomesDic[outcome.betTypeOutcomeId]) {
          continue;
        }

        const ind2 = bet.betOutcomesDic[outcome.betTypeOutcomeId].findIndex(bo => bo.id === outcome.id);
        if (ind2 > -1) {
          bet.betOutcomesDic[outcome.betTypeOutcomeId].splice(ind2, 1);
        }
        if (bet.betOutcomesDic[outcome.betTypeOutcomeId].length === 0) {
          delete bet.betOutcomesDic[outcome.betTypeOutcomeId];
        }
        const ind = bet.betOutcomes.findIndex(bo => bo.id === outcome.id);
        if (ind > -1) {
          bet.betOutcomes.splice(ind, 1);
        }
      }
    }
  }

  setMostBalancedBetAsBetToShowForBetsGroup(group: IBetGroupWithBetToShowId) {
    const betsList = Object.entries(group.bets).map(([key, bet]) => bet);
    const ind = this.utilityService.getMostBalancedBetIndex(betsList);
    if (ind > -1) {
      group.betToShow = betsList[ind];
    }
  }

  updateSingleBet(betFromCahche: IBet, betToUpdate: IBet) {
    betToUpdate.sbv = betFromCahche.sbv;
    betToUpdate.orderNo = betFromCahche.orderNo;
    betToUpdate.isInOffer = betFromCahche.isInOffer;
    betToUpdate.isPlayable = betFromCahche.isPlayable;
    betToUpdate.isMostBalanced = betFromCahche.isMostBalanced;
    // betToUpdate.isFinished = betFromCahche.isFinished;
    betToUpdate.isLive = betFromCahche.isLive;
    betToUpdate.cashBackEnabled = betFromCahche.cashBackEnabled;
  }

  updateSingleBetOutcome(btoFromCahche: IBetOutcome, btoToUpdate: IBetOutcome) {
    btoToUpdate.cashBackEnabled = btoFromCahche.cashBackEnabled;
    btoToUpdate.isInOffer = btoFromCahche.isInOffer;
    btoToUpdate.isLive = btoFromCahche.isLive;
    btoToUpdate.isPlayable = btoFromCahche.isPlayable;
    btoToUpdate.oldOdd = btoToUpdate.odd;
    btoToUpdate.odd = btoFromCahche.odd;
    // if (btoToUpdate.oldOdd > btoToUpdate.odd) {
    //   if (btoToUpdate.higherLowerOdd === BetOutcomeOddDifference.Lower) {
    //     btoToUpdate.higherLowerOdd = BetOutcomeOddDifference.Lower2;
    //   } else {
    //     btoToUpdate.higherLowerOdd = BetOutcomeOddDifference.Lower;
    //   }
    // }

    // if (btoToUpdate.oldOdd < btoToUpdate.odd) {
    //   if (btoToUpdate.higherLowerOdd === BetOutcomeOddDifference.Higher) {
    //     btoToUpdate.higherLowerOdd = BetOutcomeOddDifference.Higher2;
    //   } else {
    //     btoToUpdate.higherLowerOdd = BetOutcomeOddDifference.Higher;
    //   }
    // }
    btoToUpdate.orderNo = btoFromCahche.orderNo;
    btoToUpdate.resultStatus = btoFromCahche.resultStatus;
    btoToUpdate.description = btoFromCahche.description;
  }
}
